import type {PlaceholderBlock} from 'analysis-tool/data-layout/DataLayoutTypes';

export const PLACEHOLDER_BLOCK: PlaceholderBlock = {type: 'PLACEHOLDER'};

export const DEFAULT_LAYOUT_ROWS = 2;
export const DEFAULT_LAYOUT_COLUMNS = 2;

export const MIN_LAYOUT_ROWS = 1;
export const MIN_LAYOUT_COLUMNS = 1;
export const MAX_LAYOUT_ROWS = 12;
export const MAX_LAYOUT_COLUMNS = 6;
